import React, { useEffect } from 'react';
import StepHeader from 'components/common/headers/StepHeader';
import { observer } from 'mobx-react-lite';
import { ClipboardCopy } from '@insurancemenu/imenu-components-lib';
import { useEmployeeSelfRegisterLinkPageStore } from 'store/pages/utility/employee-self-register-link/pageStore';
import { COPY_LINK_BUTTON_TEST_ID, LINK_TEST_ID } from '../constants';
import {
  ContentWrapperStyled,
  LinkStyled,
  StepBodyStyled,
  StepSubtitleStyled,
  StepWrapperStyled,
  TitleAccentedWordStyled,
} from './styles';

export const GenerateLinkStep: React.FC = observer(() => {
  const { selfRegisterLink, getInitialData } = useEmployeeSelfRegisterLinkPageStore();

  useEffect(() => {
    void getInitialData();
  }, []);

  return (
    <StepWrapperStyled>
      <StepHeader
        stepNumber="1"
        stepTitle="Generate Self-Registration Link"
        stepSubtitle={
          <StepSubtitleStyled>
            Generate a unique link employees can use to register themselves. You&apos;ll see them on the Add Employees
            page under the <TitleAccentedWordStyled>&ldquo;Link&rdquo; </TitleAccentedWordStyled> method once
            they&apos;ve registered.
          </StepSubtitleStyled>
        }
      />
      <StepBodyStyled>
        <ContentWrapperStyled>
          <LinkStyled data-test-id={LINK_TEST_ID}>{selfRegisterLink}</LinkStyled>
          <ClipboardCopy textToCopy={selfRegisterLink} buttonText="Copy Link" data-test-id={COPY_LINK_BUTTON_TEST_ID} />
        </ContentWrapperStyled>
      </StepBodyStyled>
    </StepWrapperStyled>
  );
});
